import { render, staticRenderFns } from "./ReminderSettings.vue?vue&type=template&id=5bbe63ef&scoped=true"
import script from "./ReminderSettings.vue?vue&type=script&lang=js"
export * from "./ReminderSettings.vue?vue&type=script&lang=js"
import style0 from "./ds-common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ReminderSettings.vue?vue&type=style&index=1&id=5bbe63ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe63ef",
  null
  
)

export default component.exports